'use client';

import { Box, Flex, Text, Button } from '@chakra-ui/react';
import Image from 'next/image';
import { BRAND_CATEGORIES } from '@/constants/product/brandCategories';
import LucideIcon from '@/components/ui/LucideIcon';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';

const BrandCategoriesSection = () => {
  return (
    <SectionContainer
      containerInnerProps={{ backgroundColor: 'neutral.5', paddingY: { base: 12, tablet: 12, desktop: 16 }, gap: 12 }}
    >
      <Box>
        <SafeLink
          href="/all-brands/"
          width={{ base: '100%', tablet: 'fit-content' }}
          _hover={{ textDecoration: 'none' }}
        >
          <Flex alignItems={{ base: 'flex-start', tablet: 'center' }} gap={{ base: 3, tablet: 4 }}>
            <Text color="neutral.100" textStyle="heading2" fontWeight="regular">
              Discover the Best in Korean Skincare
            </Text>
            <Flex alignItems="center" justify="center" h="34px">
              <LucideIcon name="ChevronRight" boxSize={6} color="neutral.100" />
            </Flex>
          </Flex>
        </SafeLink>
      </Box>
      <Flex direction="column" gap={6} width="100%">
        {BRAND_CATEGORIES.map((category, index) => (
          <Box key={category.id}>
            {index > 0 && <Box borderTop="1px solid" borderColor="neutral.10" mb={6} width="100%" />}
            <Flex alignItems="center" direction={{ base: 'column', desktop: 'row' }} gap={4} width="100%">
              <Text
                color="neutral.70"
                textStyle="body3"
                fontWeight="medium"
                width={{ base: '100%', desktop: '25%' }}
                marginBottom={{ base: 4, desktop: 0 }}
              >
                {category.title}
              </Text>

              <Flex
                width="100%"
                overflowX={{ base: 'auto', desktop: 'visible' }}
                css={{
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                  msOverflowStyle: 'none',
                  scrollbarWidth: 'none',
                }}
              >
                <Flex
                  flex="1"
                  flexWrap={{ base: 'nowrap', desktop: 'wrap' }}
                  justifyContent={{ base: 'flex-start', tablet: 'center', desktop: 'flex-end' }}
                  gap={4}
                  paddingBottom={{ base: 2, desktop: 0 }}
                >
                  {category.brands.map((brand) => (
                    <SafeLink href={brand.url} key={brand.name}>
                      <Box
                        alignItems="center"
                        bg="common.100"
                        border="1px solid"
                        borderColor="neutral.10"
                        borderRadius="90px"
                        display="flex"
                        height={{ base: '80px', tablet: '112px' }}
                        justifyContent="center"
                        overflow="hidden"
                        width={{ base: '80px', tablet: '112px' }}
                        transition="transform 0.2s, box-shadow 0.2s"
                        _hover={{
                          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                          cursor: 'pointer',
                        }}
                        minWidth={{ base: '80px', tablet: 'auto' }}
                        position="relative"
                      >
                        <Image
                          alt={brand.imageAlt}
                          width={90}
                          height={90}
                          src={brand.imageUrl}
                          style={{
                            objectFit: 'contain',
                            height: 'auto',
                            width: 'auto',
                            maxWidth: '90px',
                            maxHeight: '90px',
                          }}
                          sizes="(max-width: 767px) 80px, 112px"
                        />
                      </Box>
                    </SafeLink>
                  ))}
                </Flex>
              </Flex>
            </Flex>
          </Box>
        ))}
      </Flex>

      <Box textAlign="center">
        <SafeLink href="/all-brands/" width={{ base: 'full', tablet: '332px' }}>
          <Button
            backgroundColor="transparent"
            border="1px solid"
            borderColor="brand.50"
            borderRadius="8px"
            color="brand.50"
            textStyle="body3"
            fontWeight="regular"
            height="48px"
            padding={4}
            width={{ base: 'full', tablet: '332px' }}
            _hover={{
              backgroundColor: 'brand.50',
              color: 'common.100',
              borderColor: 'common.100',
            }}
          >
            View all
          </Button>
        </SafeLink>
      </Box>
    </SectionContainer>
  );
};

export default BrandCategoriesSection;
